import { Reducer } from 'umi';

export const namespace = 'customDashboard';


export interface customDashboardType {
  isHideCustomLeaveModal: boolean;
}

export interface customType {
  namespace: string;
  state: customDashboardType;
  effects: {
  };
  reducers: {
    save: Reducer<customDashboardType>;
  };
}

const CustomDashboardModal: customType = {
  namespace,
  state: {
    isHideCustomLeaveModal: false,
  },

  effects: {

  },
  reducers: {
    save(state: customDashboardType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
};

export default CustomDashboardModal;

